import React, { useState, useEffect } from 'react';
import { styled, } from '@mui/system';
import { Container, FormDiv, ButtonCust } from "../styles/Product.style";
import { purchase_order_list, order_list_total } from "../services/order";
import EditIcon from '@mui/icons-material/Edit';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import {
    TableContainer, Table, TableHead, IconButton, Box,
    TableRow, TableCell, TableBody, TablePagination, CircularProgress, Chip,
    Typography, TextField, FormControl, InputLabel, Select, MenuItem
} from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import { useNavigate, useParams, Link } from 'react-router-dom';
import { BUTTON_STYLE } from "../../../../constants/style";
import FactCheckIcon from '@mui/icons-material/FactCheck';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import CategoryIcon from '@mui/icons-material/Category';
import BillingInfoModal from './BillingInfoModal';
const StyledContainer = styled(Container)({
    padding: '20px',
    marginTop: '20px',
});

const StyledTableContainer = styled(TableContainer)({
    maxHeight: 700,
    borderRadius: '8px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
});

const ProductList: React.FC = () => {
    const navigate = useNavigate();
    const [isModalVisible, setIsModalVisible] = useState<any>(false);
    const [billing_purchase_order_Id, setbilling_purchase_order_Id] = useState<any>();
    const { startDateFilter, endDateFilter } = useParams();
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalRows, setTotalRows] = useState(0);
    const [startDate, setStartDate] = useState<string | null>(null);
    const [endDate, setEndDate] = useState<string | null>(null);
    const [searchInput, setSearchInput] = useState<string>('');
    const [purchaseOrderId, setQuotationId] = useState<string>('');
    const [orderStatus, setOrderStatus] = useState<string>('');
    const [status, setStatus] = useState<string>('');

    // useEffect(() => {
    // fetchProductTotal();
    // }, []);
    // useEffect(() => {
    //     if (startDateFilter && Number(startDateFilter) > 0 && endDateFilter && Number(endDateFilter) > 0) {
    //         const formattedStartDate = new Date(Number(startDateFilter)).toISOString().split('T')[0];
    //         const formattedEndDate = new Date(Number(endDateFilter)).toISOString().split('T')[0];

    //         setStartDate(formattedStartDate);
    //         setEndDate(formattedEndDate);
    //     }
    // }, [startDateFilter, endDateFilter]);
    useEffect(() => {
        if (startDateFilter && Number(startDateFilter) > 0 && endDateFilter && Number(endDateFilter) > 0) {
            // Convert the filter start and end timestamps to Date objects
            const startDate = new Date(Number(startDateFilter));
            const endDate = new Date(Number(endDateFilter));

            // Convert the Date object to UTC date and format as YYYY-MM-DD
            const formattedStartDate = startDate.toISOString().split('T')[0];
            const formattedEndDate = endDate.toISOString().split('T')[0];

            // Set the formatted dates
            setStartDate(formattedStartDate);
            setEndDate(formattedEndDate);
        }
    }, [startDateFilter, endDateFilter]);


    useEffect(() => {
        if (page || startDate || endDate || searchInput || purchaseOrderId || orderStatus || status) {
            setPage(0);

        }

    }, [rowsPerPage, startDate, endDate, searchInput, purchaseOrderId, orderStatus, status]);
    useEffect(() => {

        fetchProductTotal();
        fetchOrders();
    }, [page, rowsPerPage, startDate, endDate, searchInput, purchaseOrderId, orderStatus, status]);

    const fetchProductTotal = async () => {
        const response: any = await order_list_total(startDate ? "" + new Date(startDate).getTime() + "" : "",
            endDate ? "" + new Date(endDate).getTime() + "" : "",
            searchInput && searchInput != "" ? searchInput : "",
            purchaseOrderId && purchaseOrderId != "" ? purchaseOrderId : "",
            orderStatus && orderStatus !== "" ? orderStatus : "",
            status && status !== "" ? status : "",
        );
        setTotalRows(response && response.data?.purchase_ordertotal && response.data?.purchase_ordertotal.length > 0
            ? response.data?.purchase_ordertotal[0].quotationTotal : 0);
    };

    const fetchOrders = async () => {
        setLoading(true);
        try {
            const response: any = await purchase_order_list(page + 1, rowsPerPage,
                startDate ? "" + new Date(startDate).getTime() + "" : "", endDate ? "" + new Date(endDate).getTime() + "" : "",
                searchInput && searchInput != "" ? searchInput : "",
                purchaseOrderId && purchaseOrderId != "" ? purchaseOrderId : "",
                orderStatus && orderStatus !== "" ? orderStatus : "",
                status && status !== "" ? status : "",
            );
            setOrders(response.data.purchase_order);
        } catch (error) {
            console.error('Error fetching orders:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleDetail = (productId: number) => {
        navigate(`/admin/purchase_order_detail/${productId}`);
    };

    const handleEdit = (productId: number) => {
        navigate(`/admin/purchase_order_edit/${productId}`);

    };

    const handleCreate = () => {
        navigate(`/admin/purchase_order/create`);
    };
    const handleBilling_info = (id: number) => {
        setbilling_purchase_order_Id(id);
        setIsModalVisible(true);
    };

    const handleStartDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setStartDate(event.target.value);
    };

    const handleEndDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setEndDate(event.target.value);
    };

    return (
        <Container>
            <FormDiv>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                    <Typography variant="h6">Purchase Order List</Typography>
                    <ButtonCust onClick={handleCreate} sx={BUTTON_STYLE}>
                        Add
                    </ButtonCust>
                </Box>

                {/* Start and End Date Filters */}
                <Box sx={{ display: 'flex', gap: '16px', marginTop: '20px' }}>
                    <TextField
                        label="Start Date"
                        type="date"
                        value={startDate || ''}
                        onChange={handleStartDateChange}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        size="small"
                    />
                    <TextField
                        label="End Date"
                        type="date"
                        value={endDate || ''}
                        onChange={handleEndDateChange}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        size="small"
                    />
                    <TextField
                        label="Users Name"
                        variant="outlined"
                        value={searchInput}
                        onChange={(e) => setSearchInput(e.target.value)}
                        type="text"
                        size="small"
                        placeholder="Search your Users"
                    />
                    <TextField
                        label=" Quotation Id"
                        variant="outlined"
                        value={purchaseOrderId}
                        onChange={(e) => setQuotationId(e.target.value)}
                        type="text"
                        size="small"
                        placeholder="Search Quotation Id"
                    />

                    <FormControl
                        style={{ width: "200px" }}
                        size="small"
                    >
                        <InputLabel>
                            Status
                        </InputLabel>
                        <Select
                            size="small"
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={status}
                            label="Status"
                            onChange={(e) => setStatus(e.target.value)}
                        >  <MenuItem value={""}>None</MenuItem>

                            <MenuItem value={"Pending"}>Pending</MenuItem>
                            <MenuItem value={"Processing"}>Processing</MenuItem>
                            <MenuItem value={"Shipped"}>Shipped</MenuItem>
                            <MenuItem value={"Completed"}>Completed</MenuItem>
                        </Select>
                    </FormControl>
                    <FormControl
                        style={{ width: "200px" }}
                        size="small"
                    >
                        <InputLabel>
                            Order Status
                        </InputLabel>
                        <Select
                            size="small"
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={orderStatus}
                            label="Order Status"
                            onChange={(e) => setOrderStatus(e.target.value)}
                        >
                            <MenuItem value={""}>None</MenuItem>
                            <MenuItem value={"Pending"}>Pending</MenuItem>
                            <MenuItem value={"Granted"}>Granted</MenuItem>
                        </Select>
                    </FormControl>

                </Box>

                <StyledContainer>
                    {loading ? (
                        <CircularProgress />
                    ) : (
                        <StyledTableContainer>
                            <Table stickyHeader aria-label="sticky table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell size="medium">No.</TableCell>
                                        <TableCell size="medium">Firm</TableCell>
                                        <TableCell size="medium">User</TableCell>
                                        <TableCell size="medium">Employee</TableCell>
                                        <TableCell size="medium">Quotation No</TableCell>
                                        <TableCell size="medium"> Date</TableCell>
                                        <TableCell size="medium">Qty</TableCell>
                                        <TableCell size="medium">Total Price</TableCell>
                                        <TableCell size="medium">Location</TableCell>
                                        <TableCell size="medium">Status</TableCell>
                                        <TableCell size="medium">Order Status</TableCell>
                                        <TableCell size="medium">Action</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {orders && orders.length > 0 && orders.map((order: any, index) => (
                                        <TableRow key={order.id}>
                                            <TableCell size="small">PO{order.id}</TableCell>
                                            <TableCell size="small">{order.firm}</TableCell>
                                            <TableCell size="small">{order.fullName}  <br />{order.mobileNo}</TableCell>
                                            <TableCell size="small">{order.employee}</TableCell>
                                            <TableCell align="center">
                                                {
                                                    order.quotationId ? <>UBC-QU-{order.quotationId}</> : "-"
                                                }
                                            </TableCell>
                                            <TableCell size="small">{new Date(order.quotationDate).toLocaleDateString('en-GB')}</TableCell>
                                            <TableCell size="small">{order.totalQty}</TableCell>
                                            <TableCell size="small">{order.totalPrice}</TableCell>
                                            <TableCell size="small">{order.location}</TableCell>
                                            <TableCell size="small">
                                                <Chip label={order.status} color={
                                                    order.status === "Completed"
                                                        ? "success"
                                                        : order.status === "Pending"
                                                            ? "info"
                                                            : order.status === "Processing"
                                                                ? "warning"
                                                                : order.status === "Shipped"
                                                                    ? "secondary"
                                                                    : "default"
                                                } size="small" />
                                            </TableCell>
                                            <TableCell size="small">
                                                <Chip label={order.orderStatus ? order.orderStatus : "None"}
                                                    color={
                                                        order.orderStatus && order.orderStatus === "Granted" ?
                                                            "success" : "primary"} size="small" />
                                            </TableCell>

                                            <TableCell size="small">
                                                <Tooltip title="P.O. Detail">
                                                    <IconButton onClick={() => handleDetail(order.id)}>
                                                        <RemoveRedEyeIcon />
                                                    </IconButton>
                                                </Tooltip>
                                                <Tooltip title="P.O. Edit">
                                                    <IconButton onClick={() => handleEdit(order.id)}>
                                                        <EditIcon />
                                                    </IconButton>
                                                </Tooltip>
                                                <Tooltip title="Delivery challan">
                                                    <Link to={`/admin/delivery-challan/${order.id}`}>
                                                        <IconButton >
                                                            <FactCheckIcon />
                                                        </IconButton>
                                                    </Link>
                                                </Tooltip>
                                                <Tooltip title="Pending Products">
                                                    <Link to={`/admin/pending-products/${order.id}`}>
                                                        <IconButton >
                                                            <CategoryIcon />
                                                        </IconButton>
                                                    </Link>
                                                </Tooltip>
                                                <Tooltip title="Billing Info">
                                                    <IconButton onClick={() => handleBilling_info(order.id)}>
                                                        <CurrencyRupeeIcon />
                                                    </IconButton>
                                                </Tooltip>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                            <TablePagination
                                rowsPerPageOptions={[10, 25, 50]}
                                component="div"
                                count={totalRows}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                            />
                        </StyledTableContainer>
                    )}
                </StyledContainer>
            </FormDiv>
            <BillingInfoModal purchaseOrderId={billing_purchase_order_Id}
                isModalVisible={isModalVisible}
                setIsModalVisible={setIsModalVisible} />
        </Container>
    );
};

export default ProductList;
